import {
  SearchCheck,
  Wrench,
  Lightbulb,
  Plug,
  CircuitBoard,
  BatteryCharging,
  ClipboardCheck,
  Cable,
} from "lucide-react";

export const PHONE_DISPLAY = "01268 555 000";
export const PHONE_TEL = "tel:+441268555000";
export const EMAIL = "hello@essexsparkelectrical.co.uk";

export const services = [
  {
    icon: SearchCheck,
    title: "Fault Finding",
    text: "Power cutting out or something not right? We trace electrical faults methodically and explain the fix in plain English.",
  },
  {
    icon: Wrench,
    title: "Electrical Repairs",
    text: "From damaged cabling to faulty fittings, we carry out safe, lasting repairs around your home or premises.",
  },
  {
    icon: Lightbulb,
    title: "Lighting Installation",
    text: "Indoor and outdoor lighting fitted neatly — LED upgrades, feature lighting, garden and security lights.",
  },
  {
    icon: Plug,
    title: "Socket & Switch Installation",
    text: "Extra sockets, USB outlets, dimmers and replacement switches, installed and properly tested.",
  },
  {
    icon: CircuitBoard,
    title: "Consumer Unit Upgrades",
    text: "Modern consumer unit replacements bringing your home's electrical protection up to date.",
  },
  {
    icon: BatteryCharging,
    title: "EV Charger Installation",
    text: "Home and workplace EV charge points supplied, installed and set up ready to use.",
  },
  {
    icon: ClipboardCheck,
    title: "EICR / Electrical Inspections",
    text: "Condition reports for homeowners, landlords and buyers — clear findings, no jargon.",
  },
  {
    icon: Cable,
    title: "Rewiring",
    text: "Full and partial rewires carried out carefully, with minimal disruption and a tidy finish.",
  },
];

export const areas = [
  "Basildon",
  "Laindon",
  "Pitsea",
  "Wickford",
  "Billericay",
  "Brentwood",
  "Southend",
];

export const reviews = [
  {
    quote:
      "Really helpful from start to finish. Turned up when promised and explained everything clearly.",
    name: "Sarah M.",
    area: "Billericay",
  },
  {
    quote:
      "Quoted quickly, did a tidy job on our new consumer unit and left everything spotless.",
    name: "James T.",
    area: "Wickford",
  },
  {
    quote:
      "Sorted a lighting fault the same week. Fair price and easy to deal with throughout.",
    name: "Karen P.",
    area: "Basildon",
  },
  {
    quote:
      "Phoned about a tripping fuse board on the Monday, sorted by the Wednesday. No fuss, fair price.",
    name: "Dave R.",
    area: "Pitsea",
  },
  {
    quote:
      "Very tidy worker. New sockets fitted throughout the house and you wouldn't know he'd been.",
    name: "Helen W.",
    area: "Laindon",
  },
  {
    quote:
      "Clear quote, arrived on time and talked us through the inspection results properly. Would happily use again.",
    name: "Mark & Julie S.",
    area: "Brentwood",
  },
];


const img = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=800&q=80`;

export const gallery = [
  {
    src: img("photo-1621905252507-b35492cc74b4"),
    title: "Consumer unit upgrade",
    area: "Billericay",
    alt: "Electrician working carefully on household wiring",
  },
  {
    src: img("photo-1513506003901-1e6a229e2d15"),
    title: "Feature lighting install",
    area: "Brentwood",
    alt: "Warm feature light bulb glowing",
  },
  {
    src: img("photo-1565814329452-e1efa11c5b89"),
    title: "Kitchen LED lighting",
    area: "Basildon",
    alt: "Row of modern LED light bulbs",
  },
  {
    src: img("photo-1558618666-fcd25c85cd64"),
    title: "Fault repair callout",
    area: "Wickford",
    alt: "Electrician inspecting a fitting with a head torch",
  },
];